export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.server) return;

  await useAppUserData().initializeUserClaims();

  console.log("Done initializing user claims");

});
